{
  "sections": [
    {
      "icon": "pi pi-home",
      "label": "Home",
      "routerLink": "/home"
    },
    {
      "icon": "pi pi-check-square",
      "label": "Order Entry",
      "routerLink": "/order-entry",
      "data": {
        "title": "Order Emtry"
      },
      "componentPath": "order-entry/order-entry.component" 
    },
    {
      "icon": "pi pi-cog",
      "label": "Admin",
      "routerLink": "/orders-by-district-in-sap",
      "children": [
        {
          "icon": "",
          "label": "by District, Date, in SAP",
          "routerLink": "/orders-by-district-in-sap"
        },
        {
          "icon": "",
          "label": "by Date Modified",
          "routerLink": "/orders-by-date-modified"
        },
        {
          "icon": "",
          "label": "by Name Modified",
          "routerLink": "/orders-by-name"
        }
       
      ]
    },
    {
      "icon": "pi pi-map",
      "label": "Dispatch View",
      "routerLink": "/dispatchview",
      "children": [
        {
          "icon": "",
          "label": "Districts",
          "routerLink": "/districts"
        }
       
      ]
    },
    {
      "icon": "pi pi-file",
      "label": "All Records",
      "routerLink": "/allrecords",
      "children": [
        {
          "icon": "",
          "label": "by Call Date",
          "routerLink": "/bycalldate"
        },
        {
          "icon": "",
          "label": "by Districts",
          "routerLink": "/bydistricts"
        },
        {
          "icon": "",
          "label": "by Analyst Status",
          "routerLink": "/byanalyststatus"
        },
        {
          "icon": "",
          "label": "by Dispatch Status",
          "routerLink": "/bydispatchstatus"
        },
         {
          "icon": "",
          "label": "by Submitter",
          "routerLink": "/bysubmitter"
        },
         {
          "icon": "",
          "label": "by Type",
          "routerLink": "/bytype"
        }
        
       
      ]
    }
  ],
    
  "utilities": []
 
}
